import { render, staticRenderFns } from "./revive.vue?vue&type=template&id=2bcd70cb&scoped=true"
import script from "./revive.vue?vue&type=script&lang=js"
export * from "./revive.vue?vue&type=script&lang=js"
import style0 from "./revive.vue?vue&type=style&index=0&id=2bcd70cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd70cb",
  null
  
)

export default component.exports